import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Picker from 'rc-calendar/lib/Picker'
import Calendar from 'rc-calendar'
import { useRcCalendarLocale } from 'src/hooks'

/**
 * A component that triggers a date picker on click on its children
 */
const DatePicker = ({ color, allowEmpty, disabledDate, value, onChange, disabled, children, ...props }) => {
  const calendar = (
    <Calendar
      showToday={false}
      disabledDate={disabledDate}
      locale={useRcCalendarLocale()}
      {...(!allowEmpty && { clearIcon: <span /> })}
    />
  )

  return (
    <Picker
      placement="bottomRight"
      calendar={calendar}
      disabled={disabled}
      value={value ? moment(value) : undefined}
      onChange={onChange && (value => onChange(value && value.toDate()))}
    >
      {({ value, open }) =>
        children({
          value: value ? moment(value).format('L') : '',
          open,
          active: open,
          disabled,
          ...props,
        })
      }
    </Picker>
  )
}

DatePicker.defaultProps = {
  color: 'light',
  allowEmpty: true,
  disabledDate: () => false,
}

DatePicker.propTypes = {
  /**
   * The date value
   */
  value: PropTypes.any,
  /**
   * Whether the date picker should be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Children render prop.
   */
  children: PropTypes.func,
  /**
   * Handler being called on each change
   */
  onChange: PropTypes.func,
  /**
   * Allow clearing value (inspired by rc-time-picker http://react-component.github.io/time-picker/)
   */
  allowEmpty: PropTypes.bool,
  /**
   * The popup color.
   */
  color: PropTypes.string,
  /**
   * Whether to disable select of current date
   */
  disabledDate: PropTypes.func,
}

export default DatePicker
